import { ChevronRight, KeyboardArrowDown } from '@material-ui/icons';
import QRDownloader from 'components/Utility/QRDownloader';
import URLPreview from 'components/Utility/URLPreview';
import React, { useLayoutEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import EditButton from '../../../MenuEditor/components/shared/EditButton';
import JoinedGroup from '../../../MenuEditor/components/shared/JoinedGroup';
import getServiceTypeLabel from './utils/getServiceTypeLabel';

const SectionWrapper = styled.div`
  background: #ffffff;
  border-bottom: 1px solid #eeeeee;
  padding-left: 12px;
`;

const OptionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  @media (max-width: 900px) {
    width: 15px;
  }
`;

const Container = styled.div`
  margin-left: 32px;
  margin-top: 30px;
  margin-bottom: 30px;

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    margin-left: 11px;
  }
`;

const TextWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 30px;
  font-size: '15px';
`;

const BigUrl = styled.div`
  margin-top: 20px;
  margin-bottom: 35px;

  @media (max-width: 900px) {
    width: 90%;
  }
`;

const ArrowDiv = styled.div`
  @media (max-width: 900px) {
    margin-top: -4px;
  }
`;
const ImageBox = styled.div`
  width: 200px;
  height: 200px;
  border-radius: 8px;
  margin-left: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #afafaf;
  overflow: hidden;
  margin-right: 16px;

  @media only screen and (max-width: 900px) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    position: relative;
  }
`;
const EditWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-right: 20px;
  @media only screen and (max-width: 900px) {
    margin-left: -30px;
  }
`;

const EditText = styled.p`
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 13px;
  text-align: right;
  letter-spacing: -0.2px;
  color: #797979;
  margin-right: 10px;
`;
const VenueDetailsWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
`;

const VenueImages = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  cursor: pointer;
`;

const VenueImagePlaceholder = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  cursor: pointer;
  background: #fafafa;
  border: 1px solid #dedede;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1px;
  margin-top: -10px;
`;

const VenueName = styled.p`
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 16px;
  letter-spacing: -0.4px;
  color: #000000;
`;

const VenueUrl = styled.span`
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: -0.2px;
  color: #797979;

  @media (max-width: 900px) {
    font-size: 10px;
  }
`;

const UrlWrapper = styled.div`
  margin-left: 10px;
`;

function GroupOwnerView({ group, switchToEditMode, expanded = false }) {
  const containerRef = useRef();
  useLayoutEffect(() => {
    if (expanded) {
      containerRef.current.scrollIntoView();
    }
  }, []);

  const [showResults, setShowResults] = useState(expanded);
  const toggleResults = () => {
    setShowResults(!showResults);
  };

  return (
    <SectionWrapper ref={containerRef}>
      <OptionWrapper>
        <JoinedGroup
          dGroup
          variant="outlined"
          color="primary"
          onClick={toggleResults}
        >
          <ArrowDiv>
            {showResults ? (
              <KeyboardArrowDown
                style={{ fontSize: 25, marginTop: 4, marginRight: 2 }}
              />
            ) : (
              <ChevronRight
                style={{ fontSize: 25, marginTop: 4, marginRight: 2 }}
              />
            )}
          </ArrowDiv>
          {group.name}
        </JoinedGroup>

        <EditWrapper style={{ marginTop: '4px' }}>
          <EditText
            style={{ marginLeft: 2, marginRight: '20px', marginTop: '10px' }}
          >
            Created
          </EditText>
          <EditButton alt="Edit" onClick={() => switchToEditMode(group._id)} />
        </EditWrapper>
      </OptionWrapper>

      {!showResults ? (
        <p></p>
      ) : (
        <Container style={{ marginTop: '20px' }}>
          {group.imageUrl && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <div className="settings__section__subheading">
                <ImageBox
                  style={{
                    background: `url(${group.imageUrl}) center center`,
                    backgroundSize: 'cover',
                  }}
                ></ImageBox>
              </div>
            </div>
          )}
          <TextWrapper>
            <p style={{ fontSize: '15px' }}>{group.description}</p>
          </TextWrapper>
          <div
            className="settings__section__subheading"
            style={{ fontSize: '16px' }}
          >
            Service type
          </div>

          <p style={{ marginBottom: 32, fontSize: '15px' }}>
            {getServiceTypeLabel(group.serviceType)}
          </p>

          {Boolean(group.expandedParticipants.length) && (
            <div
              className="settings__section__subheading"
              style={{ marginBottom: 20, fontSize: '16px' }}
            >
              Venues
            </div>
          )}

          <VenueDetailsWrapper>
            {group.expandedParticipants.map(participant => (
              <IconWrapper>
                <div>
                  {participant.image_url ? (
                    <VenueImages
                      src={participant.image_url}
                      alt="venue image"
                    />
                  ) : (
                    <VenueImagePlaceholder />
                  )}
                </div>
                <UrlWrapper>
                  <VenueName>
                    {participant.name || ''}
                    <br />
                    <VenueUrl>
                      {`${process.env.REACT_APP_CUSTOMER_APP_URL}/venue/${
                        participant.url_slug || ''
                      }`}
                    </VenueUrl>
                  </VenueName>
                </UrlWrapper>
              </IconWrapper>
            ))}
          </VenueDetailsWrapper>
          <div
            className="settings__section__subheading"
            style={{ fontSize: '16px' }}
          >
            Tabb page URL
          </div>

          <BigUrl>
            <URLPreview>{`${process.env.REACT_APP_CUSTOMER_APP_URL}/m/${group.slug}`}</URLPreview>
          </BigUrl>

          <div
            className="settings__section__subheading"
            style={{ fontSize: '16px' }}
          >
            QR Code
          </div>

          <div style={{ marginTop: 20 }}>
            <QRDownloader
              style={{ display: 'flex' }}
              url={`${process.env.REACT_APP_CUSTOMER_APP_URL}/m/${group.slug}`}
            ></QRDownloader>
          </div>
        </Container>
      )}
    </SectionWrapper>
  );
}

export default GroupOwnerView;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MultiVenue/components/GroupDetails/GroupOwnerView.jsx